import { pickBy, isNil } from "lodash"

/**
 * Request object for fetching paginated recipients from an advanced filter batch
 * 
 * @description Returns a paginated list of recipients in a batch. Supports sorting and search.
 * 
 * GET /communities/{communityId}/notices/advanced-filter-recipients/batch/{batchId}/recipients
 * 
 * @see https://d6group.atlassian.net/wiki/spaces/d6/pages/403341313/Portal+API+Advanced+Filter+Recipients+API
 */
class GetAdvancedFilterBatchRecipientsRequest {

    /**
     * @param {Object} params
     * @param {number} [params.page=1] - Page number
     * @param {number} [params.perPage=25] - Items per page (max 100)
     * @param {string} [params.sort] - Sort field(s), e.g. 'first_name,-last_name'
     * @param {string} [params.search] - Search query
     */
    constructor({ 
        page = 1,
        perPage = 25,
        sort,
        search,
    }) {
        this.page = page
        this.perPage = Math.min(perPage, 100) // Max 100 per API docs
        this.sort = sort
        this.search = search
    }

    getPayload = () => {
        const payload = {
            "page": this.page,
            "per_page": this.perPage,
            "sort": this.sort,
            "search": this.search,
        }

        // Remove null/undefined values
        return pickBy(payload, (value) => !isNil(value))
    }
}

export default GetAdvancedFilterBatchRecipientsRequest
